<template>
  <div
    class="flex justify-between border-gray py-3.75 first:border-t"
    :class="[isLast ? 'border-b-0' : 'border-b']"
  >
    <div class="flex flex-col gap-1">
      <p class="bp1680-text-23 leading-[120%] md:text-[17px] xl:text-xl">
        {{ resolveEmployeeFullName(employeeData) }}
      </p>
      <p
        v-if="employeeData.role"
        class="bp1680-text-19 text-sm leading-[115%] text-gray-darker xl:text-[17px] xl:leading-[125%]"
      >
        {{ employeeData.role }}
      </p>
      <NuxtLink
        v-if="employeeData.email"
        :to="`mailto:${employeeData.email}`"
        class="bp1680-text-19 text-sm leading-[115%] text-gray-darker transition-colors duration-100 ease-out hover:text-black xl:text-[17px] xl:leading-[125%]"
      >
        {{ employeeData.email }}
      </NuxtLink>
      <NuxtLink
        v-if="employeeData.phone"
        :to="`tel:${cleanPhone(employeeData.phone)}`"
        class="bp1680-text-19 text-sm leading-[115%] text-gray-darker transition-colors duration-100 ease-out hover:text-black xl:text-[17px] xl:leading-[125%]"
      >
        {{ employeeData.phone }}
      </NuxtLink>
    </div>

    <NuxtLink
      v-if="employeeData.perex || employeeData.content_blocks?.length > 0"
      :to="localePath(employeeData.menu_url)"
      class="text-sm leading-[115%] underline underline-offset-4 transition-all duration-100 ease-out hover:text-gray-medium md:text-[17px] xl:text-xl xl:leading-[120%]"
    >
      profil
    </NuxtLink>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { Person, DepartmentPerson } from '~/types'

interface Props {
  person: DepartmentPerson | Person
  isLast?: boolean
}

const props = defineProps<Props>()
const localePath = useLocalePath()

const cleanPhone = (phoneString: string) => {
  if (!phoneString) return ''
  return String(phoneString).replace(/[^\d+]/g, '')
}

const employeeData = computed(() => {
  if (props.person?.person) {
    return {
      ...props.person.person,
      role: props.person.function || props.person.person.role,
    }
  }

  return props.person
})
</script>
